<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VZM6Ni/tc-custom/9781439665640.jpg?1705026083350" alt="This image is the cover for the book Cold War Wisconsin"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cold War Wisconsin
      </h1>
      <p class="bookDescription body article font2">
        <p>As the Cold War gripped the world with fear of espionage and nuclear winter, everyday Wisconsinites found themselves embroiled in the struggle. For decades, the state's nuclear missiles pointed to the skies, awaiting Soviet bombers. Joseph Stalin's daughter sought refuge in the small town of Richland Center. With violence in Vietnam about to peak, a cargo ship from Kewaunee sparked a new international incident with North Korea. Manitowoc was ground zero for a Sputnik satellite crash, and four ordinary Madison youths landed on the FBI's most wanted list after the Sterling Hall Bombing. Local author and chairman of the Midwest Chapter of the Cold War Museum Chris Sturdevant shares the tales of the Badger State's role in this titanic showdown between East and West.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher Sturdevant
      </h2>
      
      <p class="authorDescription body article">Christopher Sturdevant is a children's librarian who resides in Milwaukee, Wisconsin. His interest in the Cold War began while growing up during the 1980s. Chris studied history and physics at Carroll University. He is a U.S. Air Force veteran and chairman of the Midwest Chapter of the Cold War Museum in Washington, D.C. In addition, Chris has represented Team USA in master's level track championships on three continents. His travels have taken him to North Korea, Chernobyl and Afghanistan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bcfd0b68